<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card-text>
        <h2 style="margin: 0% auto;"><b>Pedagang Perantara</b></h2>
      </v-card-text>

      <v-card-text class="pa-0 margin-title">
        
        <v-card>
          <pesanan-pengiriman-list></pesanan-pengiriman-list>
        </v-card>

      </v-card-text>

    </v-layout>
  </v-container>     
</template>

<script>
import { getUserById } from '@/api/user';

import VWidget from '@/components/VWidget';
import PesananPengirimanList from '@/components/pesananpengiriman/PesananPengirimanList'
import TambahkanPesananPengiriman from '@/components/pesananpengiriman/TambahkanPesananPengiriman'
export default {
  components: {
    VWidget,
    PesananPengirimanList,
    TambahkanPesananPengiriman,
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
      status: false
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'PesananPengiriman',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },
};
</script>